export default __webpack_public_path__ + "static/media/image-21.9755ebc4.png";